import TOCWidget from "./TOCWidget";

const InitContentAreaWithTOC = () => {
    new TOCWidget();
}

export default InitContentAreaWithTOC;